/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export const TOOL_APPROVAL_QUERY_KEYS = {
  pending: (contextId: string) => ['tool-approvals', 'pending', contextId] as const,
};
